import { useId } from 'react'
import { FieldShell } from './internal/FieldShell'
import { describedBy } from './internal/cx'

export type TextAreaProps = {
  label: string
  value: string
  onChange: (value: string) => void
  rows?: number
  error?: string
  placeholder?: string
}

export function TextArea({ label, value, onChange, rows = 4, error, placeholder }: TextAreaProps) {
  const fieldId = useId()
  return (
    <FieldShell id={fieldId} label={label} error={error}>
      <textarea
        id={fieldId}
        className="ui-textarea"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        rows={rows}
        placeholder={placeholder}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy(error && `${fieldId}-error`)}
      />
    </FieldShell>
  )
}
